import cDataJson from '../static_files/2D_data/countryData.json';
import cPathsJson from '../static_files/2D_data/countryPaths.json';
import cProjectilesJson from '../static_files/2D_data/countryProjectiles.json';
import cBordersJson from '../static_files/2D_data/country-borders.json';

const huBbox = {
  x: 2968.8,
  y: 1078.68,
  w: 102.3,
  width: 102.3,
  h: 54.33,
  height: 54.33,
  x2: 3071.1,
  y2: 1133.01,
  cx: 3019.95,
  cy: 1105.85
};

// the default viewbox is set by the actual SVG
// we are using
// this is constant
const defaultVBoxBySVG = {
  x: 0,
  y: 0,
  w: 5800,
  h: 3000,
  width: 5800,
  height: 3000,
  x2: 5800,
  y2: 3000
};

export default {
  isLoading: true,
  countries: {
    details: cDataJson,
    paths: cPathsJson,
    projectileToHu: cProjectilesJson,
    borders: cBordersJson,
    huData: huBbox,
    activeCountryId: undefined
  },
  svg: {
    // margins: {
    //   top: 1000,
    //   bottom: 1000,
    //   left: 1000,
    //   right: 1000,
    //   topPercent: 98,
    //   bottomPercent: 98,
    //   leftPercent: 95,
    //   rightPercent: 95
    // },
    parentEl: undefined,
    parentObj: undefined,
    defaultVBox: {
      ...defaultVBoxBySVG
    },
    currentVBox: { ...defaultVBoxBySVG },
    currentZoom: 1,
    minZoom: 1,
    maxZoom: 5,
    zoomFactor: 0.5
  }
};
